import { Injectable } from '@angular/core';
import {
  HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse, HttpEventType
} from '@angular/common/http';

import { Observable, of, throwError } from 'rxjs';
import { AuthService } from './auth.service';
import { catchError, tap } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';

/** Pass untouched request through to the next request handler. */
@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private authService: AuthService, private router: Router, private activatedRoute: ActivatedRoute) { }

  /**
   *
   * @param req
   * @param next
   */
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.authService.currentState().isLoggedIn && this.authService.currentState().token) {
      req = req.clone({
        setHeaders: {
          'content-type': 'application/json',
          Authorization: `Bearer ${this.authService.currentState().token}`
        }
      });
      req.headers.append('Authorization', 'Bearer ' + this.authService.currentState().token);
      req.headers.append('content-type', 'application/json');
    }

    return next.handle(req).pipe(
      catchError(error => {
        if (error instanceof HttpErrorResponse && error.status == 401) {
          console.log('HTTP 401 received, requiring another login.');
          this.router.navigate(['login']);
        }
        else {
          return throwError(error);
        }
      })
    );
  }
}
